import { CartUpdateEvent } from '@theme/events';

const root = window.Shopify?.routes?.root || '/';
let cartRequest;
function readCart() {
  if (!cartRequest) cartRequest = fetch(`${root}cart.js`).then(r => {
    if (!r.ok) throw new Error('cart');
    return r.json();
  }).finally(() => { cartRequest = null; });
  return cartRequest;
}
class PocketOffer extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addText = this.querySelector('.pc-pocket-offer__add')?.textContent;
    this.querySelectorAll('.pc-thread input').forEach(input => {
      input.name = `pc-thread-${input.getAttribute('form')}`;
    });
    this.querySelector('.pc-pocket-offer__add')?.addEventListener('click', () => this.addPocket());
    this.addEventListener('change', () => {
      this.querySelector('.pc-pocket-offer__status').textContent = '';
      this.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
    });
    if (this.dataset.placement === 'product') {
      readCart().then(cart => this.update(cart)).catch(() => {});
      const form = this.closest('form');
      const position = () => {
        const widget = form?.querySelector('.tcustomizer-product-form');
        const target = form?.querySelector('#pc-config-total');
        if (!widget || !target) return false;
        if (this.nextElementSibling !== target) target.before(this);
        return true;
      };
      if (form && !position()) {
        const observer = new MutationObserver(() => { if (position()) observer.disconnect(); });
        observer.observe(form, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 15000);
      }
    }
  }
  update(cart) {
    const ids = Array.from(this.querySelectorAll('[data-product-id]'), el => el.dataset.productId);
    const present = cart.items?.some(item => ids.includes(String(item.product_id)));
    this.hidden = !!present;
    if (!present && this.added) {
      this.added = false;
      const button = this.querySelector('.pc-pocket-offer__add');
      button.disabled = false;
      button.textContent = this.addText;
      this.querySelector('.pc-pocket-offer__status').textContent = '';
      this.querySelector('details').open = false;
    }
  }
  async addPocket() {
    if (this.busy || this.added) return;
    const product = this.querySelector('.pc-pocket-offer__leathers input:checked');
    const thread = this.querySelector('.pc-thread input:checked');
    const status = this.querySelector('.pc-pocket-offer__status');
    const button = this.querySelector('.pc-pocket-offer__add');
    if (!product || !thread) {
      status.textContent = this.dataset.required;
      const field = this.querySelector(!product ? '.pc-pocket-offer__leathers input' : '.pc-thread input');
      field?.setAttribute('aria-invalid', 'true');
      field?.focus();
      return;
    }
    this.busy = true;
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    try {
      const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), el => el.dataset.sectionId))].slice(0, 5);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(product.value), quantity: 1, properties: { 'Farba prešitia': thread.value } }],
          sections, sections_url: window.location.pathname
        })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      this.added = true;
      status.textContent = this.dataset.added;
      button.textContent = this.dataset.added;
      let cart;
      try { cart = await readCart(); } catch (_) { cart = null; }
      const total = cart?.item_count ?? (Number(document.querySelector('[ref="cartItemCount"]')?.textContent) || 0) + 1;
      document.dispatchEvent(new CartUpdateEvent(cart || result, 'papacou-pocket-offer', {
        source: 'papacou-pocket-offer', itemCount: total, sections: result.sections
      }));
    } catch (error) {
      status.textContent = error.message || this.dataset.error;
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
      button.disabled = !!this.added;
    }
  }
}
if (!customElements.get('pc-pocket-upsell')) customElements.define('pc-pocket-upsell', PocketOffer);
document.addEventListener('cart:update', event => {
  const update = cart => document.querySelectorAll('pc-pocket-upsell[data-placement="product"]').forEach(el => el.update(cart));
  if (event.detail?.resource?.items && typeof event.detail.resource.item_count === 'number') update(event.detail.resource);
  else readCart().then(update).catch(() => {});
});
